/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import CounterOfferBar from './CounterOfferBar';
/* import SuccessCounterOfferBar from './SuccessCounterOfferBar'; */

const CounterOffer = ({
  t, data, setData, setCounterOfferModalVisible,
}) => {
  if (data && !_.isEmpty(data)) {
    return (
      <div className="row mb-4 justify-content-center">
        <div className="col col-xl-13">
          <div className="im-box im-box--white im-box--border-radius im-box--shadow">
            <CounterOfferBar
              t={t}
              data={data}
              setData={setData}
              setCounterOfferModalVisible={setCounterOfferModalVisible}
            />
          </div>
        </div>
      </div>
    );
  }

  return null;
};

CounterOffer.propTypes = {
  t: PropTypes.func,
  setData: PropTypes.func,
  setCounterOfferModalVisible: PropTypes.func,
  data: PropTypes.object,
};

export default withTranslation('common')(CounterOffer);
